import { TranslationKey } from './../../../../../types/translation/TranslationKey';

import React, { useContext } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { Tag } from '../../../../../types/tag/tag';
import { TagContext } from '../../../../../context/TagContext';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { EntityType } from '../../../../../types/comment';

interface TagFilterInnerContentProps extends FilterInnerContentProps<Tag> {
  entityType: EntityType;
}

export default function TagFilterInnerContent({
  entityType,
  filter,
  filterProps,
  setFilterProps,
}: TagFilterInnerContentProps) {
  const { tags } = useContext(TagContext);

  return (
    <InnerFilterContent
      label={t(TranslationKey.tag).plural.upper}
      filterProps={{ filterProps, setFilterProps }}
      filter={filter}
      items={[...(filterProps.tags?.get(entityType) || [])]}
      text={item => tags.get(item)?.name || t(TranslationKey.unknownTag).singular.label}
      onRemove={i => {
        filterProps.tags?.get(entityType)?.delete(i);
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
